import React, { useEffect } from 'react'
import Navbar from '../HomePage/Navbar'
import Footer from '../HomePage/Footer'
import JoinUsForm from './JoinUsForm'

function JoinUsIndex() {
  // Scroll to top on mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <Navbar />
      <JoinUsForm />
      <Footer />
    </div>
  )
}

export default JoinUsIndex
